//IMport required libraries
import React, { useEffect } from 'react';
import * as d3 from 'd3';

//Import Hooks

import useStorage from '../../../../hooks/useStorage';

//Import Styles
import './ProgressBar.scss';

const ProgressBar = ({ file, fileMetaData, setUploading, setFile, setFileMetaData, deleteFlag }) => {
  const { progress, url, progressCompressed, urlCompressed } = useStorage(file, fileMetaData, deleteFlag);

  useEffect(() => {
    if (url && urlCompressed) {
      setUploading(false);
      setFile(false);
      setFileMetaData(null);
    }
    if (deleteFlag && url && urlCompressed) {
      setUploading(false);
      setFile(false);
      setFileMetaData(null);
    }
  }, [url, progress, urlCompressed, progressCompressed, setUploading]);

  return (
    <div>
      <div className="progress-bar" style={{width: `${progress}%`}}>
        <p className='progress-number'>{`${d3.format(".0f")(progress)}%`}</p>
      </div>
      <div className="progress-bar" style={{width: `${progressCompressed}%`}}>
        <p className='progress-number'>{`${d3.format(".0f")(progressCompressed)}%`}</p>
      </div>
    </div>
  );
} 

export default ProgressBar;